import RiSearchLine from '~icons/ri/search-line'
import { useEffect, useState } from 'react';
import useDebounce from '@/utils/hooks/useDebounce';
import classNames from 'classnames';
import { Range } from '@/utils/enums/Range';
import { ibm } from '@/utils/fonts/fonts';

export default function LeaderboardSearch({onSearchQChanges, onRangeTypeChanges}: {onSearchQChanges: Function, onRangeTypeChanges: Function}) {
  const [searchQ, setSearchQ] = useState<string>('');
  const [rangeType, setRangeType] = useState<Range>(Range.alltime);
  const debouncedValue = useDebounce(searchQ, 300);

  useEffect(() => {
    onSearchQChanges(searchQ);
  }, [debouncedValue]);
  
  return (
    <>
      <section style={ibm.style} className='items-end flex flex-row flex-wrap gap-3 text-sm w-full'>
        <div className='h-14 md:h-16 bg-[#0B0B0B] px-6 py-3 gap-3 flex flex-row items-center rounded-full justify-between grow '>
          <RiSearchLine className='ml-3'/>
          <input
            placeholder='Никнейм пользователя...'
            type='search'
            value={searchQ}
            onChange={e => {
              setSearchQ(e.target.value);
            }}
            className='bg-transparent py-2 pr-3 border-none outline-none w-full'
          />
        </div>
        <section className='h-14 md:h-16 bg-[#0B0B0B] px-6 py-3 gap-3 flex flex-row items-center rounded-full justify-between grow md:grow-0'>
          <button
            onClick={() => {
                setRangeType(Range.month);
                onRangeTypeChanges(Range.month);
            }}
            className={classNames('hover:bg-zinc-800 rounded-full py-2 px-4 transition-all duration-200 ease-in-out', {'bg-zinc-800': rangeType === Range.month})}>Топ за месяц</button>
          <button
            onClick={() => {
              setRangeType(Range.alltime);
              onRangeTypeChanges(Range.alltime);
            }}
            className={classNames('hover:bg-zinc-800 rounded-full py-2 px-4 transition-all duration-200 ease-in-out', {'bg-zinc-800': rangeType === Range.alltime})}>Топ за всё время</button>
        </section>
      </section>
    </>
  )
}